import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeSk from '@angular/common/locales/sk';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from '@environment';
import * as Sentry from '@sentry/angular';

import { AppComponent } from './app/app.component';
import { config } from './app/app.config.browser';

if (environment.sentryLogging) {
  Sentry.init({
    dsn: 'https://baf1b2aafd828d685d798224ab247e00@o4509668719656960.ingest.de.sentry.io/4509668722540624',
    sendDefaultPii: true,
    environment: environment.envName,
    tracesSampleRate: 1.0,
  });
}

registerLocaleData(localeSk, 'sk');
registerLocaleData(localeEn, 'en');

function showBootstrapErrorFallback(): void {
  const loadingEl = document.querySelector('.loading-initial');
  if (loadingEl) {
    loadingEl.innerHTML = `
      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 100svh; color: white; text-align: center; padding: 2rem;">
        <span class="material-symbols-outlined" style="font-size: 80px; color: rgba(255,255,255,0.2); margin-bottom: 1rem;">cloud_off</span>
        <h2 style="font-size: 1.5rem; font-weight: 600; margin-bottom: 0.5rem;">Chyba na\u010D\u00EDtania</h2>
        <p style="color: rgba(255,255,255,0.6); margin-bottom: 1.5rem; max-width: 400px;">Aplik\u00E1ciu sa nepodarilo na\u010D\u00EDta\u0165. Sk\u00FAste to znova.</p>
        <button onclick="window.location.href='/'"
          style="padding: 0.75rem 1.5rem; background: #d4f53c; color: #0a0a0a; border: none; border-radius: 0.5rem; font-weight: 500; cursor: pointer;">
          Prejs\u0165 na hlavn\u00FA str\u00E1nku
        </button>
      </div>
    `;
  }
}

bootstrapApplication(AppComponent, config).catch((err: Error) => {
  console.error('Bootstrap failed:', err);
  showBootstrapErrorFallback();
});
